import { forwardRef, MouseEventHandler } from 'react'
import classnames from 'clsx'
import { StyledSelect } from './style'
import Feedback from '../feedback'
import { IInputProps } from '../types'

interface IProps extends IInputProps {
  children: React.ReactNode
  style?: React.CSSProperties | undefined
  onMouseDown?: MouseEventHandler<HTMLSelectElement> // 추가
}

const Select = forwardRef<HTMLSelectElement, IProps>(
  (
    {
      className,
      disabled,
      state,
      feedbackText,
      id,
      name,
      value,
      onChange,
      onBlur,
      onClick,
      onMouseDown,
      children,
      showState,
      showErrorOnly = true,
      width,
      height,
      style,
      customStyle,
      readonly,
      ...restProps
    },
    ref,
  ) => {
    return (
      <>
        <StyledSelect
          className={classnames(className, 'custom-select', {
            'readonly-style': readonly,
          })}
          ref={ref}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onClick={onClick}
          onBlur={onBlur}
          onMouseDown={onMouseDown}
          style={style}
          $state={state}
          $showState={showState}
          $showErrorOnly={showErrorOnly}
          $width={width}
          $height={height}
          $customStyle={customStyle}
          disabled={disabled}
          {...restProps}
        >
          {children}
        </StyledSelect>
        {feedbackText && showState && (
          <Feedback
            state={state}
            showState={showState}
            showErrorOnly={showErrorOnly}
          >
            {feedbackText}
          </Feedback>
        )}
      </>
    )
  },
)

Select.displayName = 'Select'

export default Select
